import { useState } from 'react';

import { CreditCardOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import SavingContract from 'components/Modal/SavingContract';

/**
 * Madde başlığındaki "Ödeme Bilgileri" butonu; tasarruf sözleşmesi modalını her sekmeden açar.
 * Yalnız `REACT_APP_FEATURE_DISPOSAL_PAYMENT` açıkken render edilir, kapalıyken aynı modal
 * Sipariş ve Telif sekmesindeki TASARRUF SÖZLEŞMESİ butonundan açılır.
 */
function PaymentInfoButton({ offer }) {
  const [open, setOpen] = useState(false);

  return (
    <Col>
      <Button
        ghost
        style={{ color: '#BF6800' }}
        onClick={() => setOpen(true)}
      >
        Ödeme Bilgileri
        <CreditCardOutlined />
      </Button>
      <SavingContract
        open={open}
        onCancel={() => setOpen(false)}
        offerStatus={offer.status}
        authors={offer.authors}
        offerID={offer.id}
        destroyOnClose
        articleLength={offer.articleLength}
        articleLengthCustom={offer.articleLengthCustom}
      />
    </Col>
  );
}
export default PaymentInfoButton;
